<template>
    <v-container>
      <v-row>
        <v-col cols="12" md="12" class="pa-6 text-left text-justify">
          <p class="text-h4 text--primary">
              <TextHeading :level=3>Formularz kontaktowy</TextHeading>
          </p>
          <contact-form />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="pa-6 text-left text-justify">
          <p class="text-h4 text--primary">
              <TextHeading :level=3>Dane kontaktowe</TextHeading>
          </p>
          <v-list dense disabled>
            <v-list-item-group
              color="primary"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-body-1">Nazwa firmy:</v-list-item-title>
                  <v-list-item-subtitle class="text-body-1">CENTRUM ROZWOJU ADMINISTRACJI SP. Z O.O.</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-body-1">Adres:</v-list-item-title>
                  <v-list-item-subtitle class="text-body-1">ul. Teofila Firlika 20/pok. 213, 71-637 Szczecin</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-body-1">NIP:</v-list-item-title>
                  <v-list-item-subtitle class="text-body-1">8522504979</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-body-1">REGON:</v-list-item-title>
                  <v-list-item-subtitle class="text-body-1">320346943</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-body-1">Nr KRS</v-list-item-title>
                  <v-list-item-subtitle class="text-body-1">0000278986</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-body-1">Numer telefonu:</v-list-item-title>
                  <v-list-item-subtitle class="text-body-1">+48 728 969 425</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-body-1">Adres email:</v-list-item-title>
                  <v-list-item-subtitle class="text-body-1">biuro@cra.com.pl</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
  </template>
  <script>
  import ContactForm from "@/modules/forms/ContactForm";
  export default {
  
    components: {ContactForm}
  }
  </script>